import {
  DEFAULT_LOCALE,
  PREFERRED_LOCALE_STORAGE_KEY,
  parseStoredLocale,
  type SupportedLocale,
} from './i18n-locale-constants';

function readStorageItem(key: string): string | null {
  if (typeof globalThis === 'undefined') {
    return null;
  }
  try {
    return globalThis.localStorage?.getItem(key) ?? null;
  } catch {
    return null;
  }
}

function writeStorageItem(key: string, value: string): void {
  try {
    globalThis.localStorage?.setItem(key, value);
  } catch {
    // ignore storage access errors
  }
}

function removeStorageItem(key: string): void {
  try {
    globalThis.localStorage?.removeItem(key);
  } catch {
    // ignore storage access errors
  }
}

export function persistPreferredLocale(locale: SupportedLocale): void {
  writeStorageItem(PREFERRED_LOCALE_STORAGE_KEY, locale);
}

export function readPersistedLocale(): SupportedLocale | undefined {
  return parseStoredLocale(readStorageItem(PREFERRED_LOCALE_STORAGE_KEY));
}

export function readNavigatorLocale(): SupportedLocale {
  if (typeof navigator === 'undefined') {
    return DEFAULT_LOCALE;
  }
  const candidates = [...(navigator.languages ?? []), navigator.language];
  for (const raw of candidates) {
    const parsed = parseStoredLocale(raw);
    if (parsed) {
      return parsed;
    }
  }
  return DEFAULT_LOCALE;
}

export function detectInitialLocale(): SupportedLocale {
  return readPersistedLocale() ?? readNavigatorLocale();
}

export function clearPreferredLocale(): void {
  removeStorageItem(PREFERRED_LOCALE_STORAGE_KEY);
}
